module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABHNCSVQICAgIfAhkiAAAANxJREFUKFOdkuERwVAQhHcroAQqoAQqQAdRAR2gAlEBOqACSkgqoAQqOLOZF3Nzk+RH7lfmXb53u/eWcGVmQwAbAEsA09QqANwAnEh+6t9Zf5hZBuAIQHBTCVqT1CWowASdW4B4vBLMJO/VMSmCmjwWuAewC907gFk6ewJYhP5BoMxPXONKMjOzajkkCzOTLw8XAi3cJilzAcm/LnhEK03gVzIDKLkDP6Cv1LJtOfLkl6NA+KqWowd/Rykdbyoro/4BCJHLOyZr0pbk5R85B0u2AiF/9duWKeS5D/kPYUJqtMg4TP0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/auditFailed.png
// module id = ACqH
// module chunks = 1